import { makeStyles } from '@material-ui/core';

export const useEditorsSectionStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    width: '100%',
  },
  search: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
    width: '100%',
    padding: '16px 0 0',
    boxSizing: 'border-box',
  },
  supportingText: {
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
    minHeight: '20px',
    paddingRight: '16px',
  },
  infoIcon: {
    width: '12px',
    height: '12px',
    fontSize: '12px',
    color: theme.palette.colors.grey110,
    flexShrink: 0,
  },
  helper: {
    color: theme.palette.colors.grey110,
    fontFamily: 'Inter, sans-serif',
    fontSize: '12px',
    fontWeight: 400,
    lineHeight: '22px',
    letterSpacing: '0.24px',
  },
  chips: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '8px',
    width: '100%',
  },
}));
